import { useState } from 'react';
import { Stack, Box } from '@mui/material';
import {
  ExpandableContentButton,
  ExpandableContentWrapper,
} from 'components/shared';
import { StrategyCompass } from 'components/equityhub/Compass/StrategyCompass';
import { StrategyCompassEditSymbols } from 'components/equityhub/Compass/StrategyCompassEditSymbols';
import { CompassProvider } from 'components/equityhub/Compass/CompassProvider';
import { CanvasContentId, CanvasComponentConfig } from 'types/canvas';
import { CompassConfig, DEFAULT_COMPASS_CONFIG } from 'types/compass';

interface CanvasCompassProps {
  id: number;
  config: CanvasComponentConfig;
  onConfigChange: (patch: Partial<CanvasComponentConfig>) => void;
}

const CanvasCompass = ({
  id,
  config: canvasConfig,
  onConfigChange,
}: CanvasCompassProps) => {
  const [localConfig, setLocalConfig] = useState<CompassConfig>(() => ({
    ...DEFAULT_COMPASS_CONFIG,
    ...(canvasConfig as Partial<CompassConfig>),
  }));

  const handleConfigChange = (patch: Partial<CompassConfig>) => {
    setLocalConfig((prev) => {
      const next = { ...prev, ...patch };
      onConfigChange(patch);
      return next;
    });
  };

  const expandableContentButtonType = `${CanvasContentId.STRATEGY_COMPASS}-${id}`;

  return (
    <CompassProvider config={localConfig} onConfigChange={handleConfigChange}>
      <ExpandableContentWrapper
        type={expandableContentButtonType}
        styleOverrides={{ p: 0.5, height: '100%' }}
      >
        <Stack sx={{ height: '100%', width: '100%', overflow: 'hidden' }}>
          <Stack
            sx={{
              px: 0.5,
              py: 0.25,
              flexDirection: 'row',
              alignItems: 'center',
              justifyContent: 'flex-end',
              flexShrink: 0,
            }}
          >
            <ExpandableContentButton type={expandableContentButtonType} />
          </Stack>
          <Stack
            sx={{
              flex: 1,
              flexDirection: 'row',
              gap: 0.5,
              overflow: 'hidden',
              minHeight: 0,
            }}
          >
            <Box
              sx={{
                flex: 2,
                minWidth: 0,
                minHeight: 0,
                overflow: 'hidden',
              }}
            >
              <StrategyCompass
                chartFullscreen={false}
                setChartFullscreen={() => {}}
              />
            </Box>
            <Box
              sx={{
                flex: 1,
                minWidth: 220,
                maxWidth: 400,
                minHeight: 0,
                overflow: 'hidden',
                display: 'flex',
                flexDirection: 'column',
              }}
            >
              <StrategyCompassEditSymbols compact />
            </Box>
          </Stack>
        </Stack>
      </ExpandableContentWrapper>
    </CompassProvider>
  );
};

export default CanvasCompass;
